<template>
  <div class="signature-pad">
    <canvas ref="canvas" class="signature-pad__canvas" :class="{ 'signature-pad__canvas--error': error }"
      @pointerdown="start" @pointermove="move" @pointerup="end" @pointerleave="end" @pointercancel="end"></canvas>
    <div class="d-flex justify-space-between align-center mt-1">
      <small class="grey--text">Firmá con el dedo o con el mouse dentro del recuadro.</small>
      <v-btn x-small text color="primary" :disabled="empty" @click="clear">Borrar</v-btn>
    </div>
  </div>
</template>

<script>
// Firma dibujada a mano. v-model: PNG en data URL ("data:image/png;base64,...") o null si esta vacia.
export default {
  name: "SignaturePad",
  props: {
    value: String,
    error: Boolean,
  },
  data() {
    return {
      drawing: false,
      empty: true,
      ctx: null,
    };
  },
  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  watch: {
    // El padre limpia la firma poniendo el valor en null
    value(value) {
      if (value == null && !this.empty) this.clear();
    },
  },
  methods: {
    // Ajusta el canvas al ancho visible y a la densidad de la pantalla (se borra lo dibujado)
    resize() {
      const canvas = this.$refs.canvas;
      const ratio = window.devicePixelRatio || 1;
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      this.ctx = canvas.getContext("2d");
      this.ctx.scale(ratio, ratio);
      this.ctx.lineWidth = 2.2;
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";
      this.ctx.strokeStyle = "#1f2d33";
      if (!this.empty) {
        this.empty = true;
        this.$emit("input", null);
      }
    },
    point(event) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    },
    start(event) {
      event.preventDefault();
      this.$refs.canvas.setPointerCapture(event.pointerId);
      this.drawing = true;
      const p = this.point(event);
      this.ctx.beginPath();
      this.ctx.moveTo(p.x, p.y);
      // Un toque sin mover deja un punto
      this.ctx.lineTo(p.x + 0.1, p.y + 0.1);
      this.ctx.stroke();
    },
    move(event) {
      if (!this.drawing) return;
      event.preventDefault();
      const p = this.point(event);
      this.ctx.lineTo(p.x, p.y);
      this.ctx.stroke();
    },
    end() {
      if (!this.drawing) return;
      this.drawing = false;
      this.empty = false;
      this.$emit("input", this.$refs.canvas.toDataURL("image/png"));
    },
    clear() {
      const canvas = this.$refs.canvas;
      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.empty = true;
      this.$emit("input", null);
    },
  },
};
</script>

<style scoped>
.signature-pad__canvas {
  display: block;
  width: 100%;
  height: 160px;
  border: 1px dashed #b8c4c9;
  border-radius: 4px;
  background: #fff;
  /* Evita que el dedo desplace la pagina mientras firma */
  touch-action: none;
  cursor: crosshair;
}
.signature-pad__canvas--error {
  border-color: #c62828;
}
</style>
